const config = {
  chainId: "0x1",
  contractAddress:"0x86Da4B633D28e3b9aBBb1413bd2f322dBb1C448a",
  targetChain: {
    chainId: "1",
  },
};

export default config;
